import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Enterprise } from '../../../../../../../types/ProductFactory';
import CompanyRegistrationSearchInput from './CompanyRegistrationSearchInput';
import { Box } from '@wegroup/design-system';
import QuestionGroupActions from '../../../ui/advisory-flow/components/question-group-components/QuestionGroupActions';
import QuestionGroupAssistantQuestion from '../../../ui/advisory-flow/components/question-group-components/QuestionGroupAssistantQuestion';
import AdvisoryFlowMainContainer from '../../../ui/advisory-flow/components/app-shell/AdvisoryFlowMainContainer';
import QuestionTitle from '../../../../../../sales-conversation/src/components/legacy/questions/QuestionTitle';
import QuestionGroupBody from '../../../ui/advisory-flow/components/question-group-components/QuestionGroupBody';
import QuestionGroupSubViewWrapper from '../../../ui/advisory-flow/components/question-group-components/QuestionGroupSubViewWrapper';

interface Props {
  hasValue?: boolean;
  previousQuestionHandler: () => void;
  nextSubView: () => void;
  handleOnChange: (arg0: boolean | Enterprise) => void;
  onCantFind: () => void;
  countryCode: string;
}

const CompanyRegistrationSearch: React.FC<React.PropsWithChildren<Props>> = ({
  hasValue,
  previousQuestionHandler,
  nextSubView,
  handleOnChange,
  onCantFind,
  countryCode,
}) => {
  const { t } = useTranslation();

  const Question = () => (
    <QuestionGroupAssistantQuestion
      question={t('FLOWS_INPUT_COMPANY_REGISTRATION_SEARCH_QUESTION')}
      description={t('FLOWS_INPUT_COMPANY_REGISTRATION_SEARCH_DESCRIPTION')}
    />
  );

  return (
    <AdvisoryFlowMainContainer>
      <Question />
      <QuestionGroupBody>
        <QuestionGroupSubViewWrapper>
          <Box width="100%" maxWidth="45rem">
            <StyledQuestionTitle>
              {t('FLOWS_INPUT_COMPANY_REGISTRATION_OR_NAME_LABEL')}:
            </StyledQuestionTitle>
            <CompanyRegistrationSearchInput
              handleOnChange={handleOnChange}
              onCantFind={onCantFind}
              countryCode={countryCode}
            />
          </Box>
        </QuestionGroupSubViewWrapper>
      </QuestionGroupBody>
      <QuestionGroupActions
        onBack={previousQuestionHandler}
        onContinue={nextSubView}
        disabledContinue={!hasValue}
      />
    </AdvisoryFlowMainContainer>
  );
};

const StyledQuestionTitle = styled(QuestionTitle)`
  width: 100%;
`;

export default CompanyRegistrationSearch;
